import { render } from "./ProductInfo.vue?vue&type=template&id=6eeee808&ts=true"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-pim-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__